import { ServerClient, serverOrigin } from "./Configs";

class StudentProgressServerClient {
  private path = "/student/progress";

  sendToEstimateStudentProgressAsync = async (token: string): Promise<void> => {
    let url: string = serverOrigin + this.path + "/estimate";

    return await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ token: token }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then(() => {
        console.log("Оценка успешно выставлена. ");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        throw error;
      });
  };
}

let studentProgressServerClient = new StudentProgressServerClient();

export default studentProgressServerClient;
